import React from 'react';
import { Document, Page, Text, View, StyleSheet, Image, Font } from '@react-pdf/renderer';

// 🚀 [영구 해결] 다운로드가 차단되는 불안정한 jsDelivr 주소를 완벽하게 버리고,
// 100% 가동률을 자랑하는 구글 공식 서체 서버(gstatic)의 Noto Sans KR 원본 주소로 강제 전환했습니다.
Font.register({
  family: 'NotoSansKR',
  src: 'https://fonts.gstatic.com/s/notosanskr/v31/PbykFmXiEBPT4ITwjUWIbSxoR_X6gA.ttf'
});

const styles = StyleSheet.create({
  page: { padding: 40, fontFamily: 'NotoSansKR', fontSize: 11, color: '#1e293b' },
  title: { fontSize: 24, textAlign: 'center', marginBottom: 20, fontWeight: 'bold', color: '#0f172a' },
  table: { width: '100%', borderWidth: 1, borderColor: '#cbd5e1', borderStyle: 'solid', marginBottom: 20 },
  row: { flexDirection: 'row', borderBottomWidth: 1, borderBottomColor: '#cbd5e1', borderBottomStyle: 'solid' },
  headerCell: { width: '20%', backgroundColor: '#f8fafc', padding: 10, textAlign: 'center', borderRightWidth: 1, borderRightColor: '#cbd5e1', borderRightStyle: 'solid', fontWeight: 'bold' },
  dataCell: { width: '30%', padding: 10, borderRightWidth: 1, borderRightColor: '#cbd5e1', borderRightStyle: 'solid' },
  dataCellLast: { width: '30%', padding: 10 },
  dataCellSpan: { width: '80%', padding: 10 },
  sectionTitle: { fontSize: 14, fontWeight: 'bold', marginBottom: 10, marginTop: 10, color: '#ef4444' },
  descBox: { padding: 15, borderWidth: 1, borderColor: '#cbd5e1', borderStyle: 'solid', minHeight: 100, marginBottom: 20, fontSize: 11, lineHeight: 1.5, backgroundColor: '#f8fafc' },
  photoGrid: { flexDirection: 'row', flexWrap: 'wrap', gap: 10, justifyContent: 'space-between' },
  photoItem: { width: '48%', marginBottom: 15 },
  photoLabel: { fontSize: 10, color: '#64748b', marginBottom: 5 },
  image: { width: '100%', height: 180, objectFit: 'cover', borderWidth: 1, borderColor: '#e2e8f0', borderStyle: 'solid', borderRadius: 6 },
  footer: { position: 'absolute', bottom: 30, left: 0, right: 0, textAlign: 'center', color: '#94a3b8', fontSize: 9 }
});

const RecallReportPdf = ({ exec, vehicle }) => {
  const actionData = vehicle?.actionData || {};

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <Text style={styles.title}>리콜 조치 이행 보고서</Text>

        {/* 1. 차량 마스터 정보 */}
        <View style={styles.table}>
          <View style={styles.row}>
            <Text style={styles.headerCell}>캠페인 명칭</Text>
            <Text style={styles.dataCellSpan}>{exec?.title || '리콜 캠페인'}</Text>
          </View>
          <View style={styles.row}>
            <Text style={styles.headerCell}>차량번호</Text>
            <Text style={styles.dataCell}>{vehicle?.carNumber || '-'}</Text>
            <Text style={styles.headerCell}>차대번호(VIN)</Text>
            <Text style={styles.dataCellLast}>{vehicle?.vin || '정보 없음'}</Text>
          </View>
          <View style={styles.row}>
            <Text style={styles.headerCell}>고객명</Text>
            <Text style={styles.dataCell}>{vehicle?.customerName || '미등록'}</Text>
            <Text style={styles.headerCell}>담당 엔지니어</Text>
            <Text style={styles.dataCellLast}>{actionData.engineer || '시스템 기록'}</Text>
          </View>
          <View style={{ flexDirection: 'row' }}>
            <Text style={styles.headerCell}>작업 일시</Text>
            <Text style={styles.dataCellSpan}>
              {actionData.actionDateTime ? actionData.actionDateTime.replace('T', ' ') : '기록 없음'}
            </Text>
          </View>
        </View>

        {/* 2. 조치 내역 */}
        <Text style={styles.sectionTitle}>[ 조치 이행 상세 내역 ]</Text>
        <View style={styles.descBox}>
          <Text>{actionData.actionDesc || '상세 조치 내역이 없습니다.'}</Text>
        </View>

        {/* 3. 현장 증빙 사진 */}
        <Text style={styles.sectionTitle}>[ 현장 작업 사진 ]</Text>
        <View style={styles.photoGrid}>
          {actionData.photos && actionData.photos.length > 0 ? (
            actionData.photos.map((src, i) => (
              <View key={i} style={styles.photoItem}>
                <Text style={styles.photoLabel}>사진 {i + 1}</Text>
                <Image src={src} style={styles.image} />
              </View>
            ))
          ) : (
            <Text style={{ color: '#94a3b8', padding: 20, textAlign: 'center', width: '100%', borderWidth: 1, borderColor: '#cbd5e1', borderStyle: 'dashed' }}>
              등록된 현장 사진이 없습니다.
            </Text>
          )}
        </View>

        <Text style={styles.footer} fixed>본 보고서는 E2BILITY CRM 시스템에서 자동 생성되었습니다.</Text>
      </Page>
    </Document>
  );
};

export default RecallReportPdf;